<template>
<div id="main" class="column is-9">
			<section class="help-pages">
			<div class="columns">
				<div class="column">
					<h1>Contact</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="card">
						<div class="card-table">
							<div class="content">
								<section class="help">
								<div class="columns">
									<div class="column">
										<p>
											Most questions can be answered in our Help section.
										</p>
										<p>
											You can also access your current and past activity by clicking Reports.
										</p>
										<p>
											If you have any questions regarding your pay, you will need to contact your administrator. Your administrator is {{ name }}, with phone number {{ format_phone }}, and e-mail address of <a :href="`mailto:${email}`">{{email}}.</a>
										</p>
										<p>
											If you are experiencing technical difficulties such as not being able to log on, change your status, or phone connections, please email your technical question or problem to your manager.
										</p>
									</div>
								</div>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
			</section>
		</div>
</template>

<script>	
	export default {
		data() {
			return {
				phone: "",
				name: "",
				email: "",
			}
		},
		computed: {
			format_phone() {
				return this.phone.toString().replace(/(\d{3})(\d{3})(\d{4})/, "1-$1-$2-$3")
			}
		},
		created() {
			const d = JSON.parse(localStorage.getItem("user"))
			this.phone = d.manager_phone
			this.name = d.manager_name
			this.email = d.manager_email
		}
	}
</script>